// this file determines what users can see in restricted sections of the app.

import { APP_ROLES, WHITELABEL } from "utils/Constants";
import { PERMISSIONS } from "./app-permissions";

type whiteLabelValues = keyof typeof WHITELABEL;
type PermissionConfigType = {
  [key in whiteLabelValues]: {
    [key: string]: string[];
  };
};

export const PERMISSION_CONFIGS: PermissionConfigType = {
  [WHITELABEL.uac]: {
    [APP_ROLES.ADMIN]: [
      PERMISSIONS.DASHBOARD.SRS_STATISTICS_CARD,
      PERMISSIONS.DASHBOARD.INFO_BOX.EAS,
      PERMISSIONS.DASHBOARD.INFO_BOX.HT_FILL_EIS_FORM,
      PERMISSIONS.DASHBOARD.VIEW_SRS_APPLICATIONS_LINK
    ],
    [APP_ROLES.SRS]: [
      PERMISSIONS.DASHBOARD.SRS_STATISTICS_CARD,
      PERMISSIONS.DASHBOARD.INFO_BOX.EAS,
      PERMISSIONS.DASHBOARD.INFO_BOX.HT_FILL_EIS_FORM,
      PERMISSIONS.DASHBOARD.VIEW_SRS_APPLICATIONS_LINK,
      PERMISSIONS.RATINGS.UAC_RATING_FORM,
      PERMISSIONS.SRS_APPLICATION.RATE_STUDENTS
    ],
    [APP_ROLES.EAS]: [
      PERMISSIONS.DASHBOARD.EAS_SEARCH_CARD,
      PERMISSIONS.DASHBOARD.INFO_BOX.EAS,
      PERMISSIONS.DASHBOARD.INFO_BOX.HT_FILL_EIS_FORM
    ],

    // role for user during create account
    [APP_ROLES.UNENCRYPTED]: []
  },
  [WHITELABEL.utas]: {
    [APP_ROLES.ADMIN]: [
      PERMISSIONS.DASHBOARD.SRS_STATISTICS_CARD,
      PERMISSIONS.DASHBOARD.VIEW_SRS_APPLICATIONS_LINK
    ],
    [APP_ROLES.SRS]: [
      PERMISSIONS.DASHBOARD.SRS_STATISTICS_CARD,
      PERMISSIONS.DASHBOARD.VIEW_SRS_APPLICATIONS_LINK,
      PERMISSIONS.RATINGS.UTAS_RATING_FORM,
      PERMISSIONS.SRS_APPLICATION.FLAG_BUTTON,
      PERMISSIONS.SRS_APPLICATION.RATE_STUDENTS
    ],
    // UTAS does not have eas role.
    // role for user during create account
    [APP_ROLES.UNENCRYPTED]: []
  }
};
